import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/modules/shared.module';

import { AppComponent } from '../app.component';
import { LoginService } from './services/login.service';
import { RouterModule } from '@angular/router';
import { routing } from './login.routing';
import { RootComponent } from './root/root.component';
import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PasswordsMismatchValidatorDirective } from './directives/validatePasswordsMatch.directive';
import { LoginDesktopComponent } from './login/desktop/login.desktop.component';
import { LoginMobileComponent } from './login/mobile/login.mobile.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,    
    RouterModule.forRoot(routing, {}),
    SharedModule
  ],
  declarations: [RootComponent, LoginComponent, ChangePasswordComponent, PasswordsMismatchValidatorDirective, LoginDesktopComponent, LoginMobileComponent],
  exports: [],
  providers: [AppComponent, LoginService]
})
export class LoginModule { }
